(ns capra.id
  "Injectable ID generation for deterministic testing.

   All Capra ID generation flows through *id-fn*.
   In production: random UUIDs (default).
   In tests: bind *id-fn* to a sequential generator for reproducibility.")

(def ^:dynamic *id-fn*
  "ID generation function. Bind to a deterministic fn in tests."
  #?(:clj  #(str (java.util.UUID/randomUUID))
     :cljs #(str (random-uuid))))

(defn gen-id
  "Generate a unique ID string. Uses *id-fn* for pluggable generation."
  ([] (*id-fn*))
  ([prefix] (str prefix "-" (*id-fn*))))
